import React from 'react'
import { NextSeo } from 'next-seo'
import Link from 'next/link'
import Image from 'next/image'
import Container from '~/components/Container'
import ImageDoubleCard from '~/components/ImageDoubleCard'
import NewsletterSignup from '~/components/NewsletterSignup'
export default function PostLayout({ children, frontMatter, postType }) {
  const { url, authorName, featuredImageURL, publishedAt, title } = frontMatter
  const seoTitle = `${title} - Mary AG`

  const data = {
    card1: {
      title: 'Explore the Grow Box'
    }
  }

  return (
    <Container className="flex-col">
      <NextSeo
        title={seoTitle}
        canonical={url}
        openGraph={{
          url,
          title: seoTitle
        }}
      />
      <article className="w-full overflow-x-hidden">
        <header className="w-full bg-black py-24 text-white">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="font-medium text-2xl md:text-3xl break-words leading-normal pb-4 md:pb-8">
              {title}
            </h2>
            {authorName && <h4 className="leading-tight pl-1">{authorName}</h4>}
            {publishedAt && (
              <h5 className="text-sm text-gray-400 font-serif pb-4 pl-1 leading-normal">
                {publishedAt}
              </h5>
            )}
          </div>
        </header>
        {featuredImageURL && (
          <section className="flex flex-col relative">
            <div className="max-w-7xl mx-auto w-full lg:px-6">
              <Image
                src={featuredImageURL}
                alt={`Featured image for ${title}`}
                width="100%"
                height="56.25%"
                layout="responsive"
                objectFit="cover"
                className="relative z-10"
              />
            </div>
            <div className="bg-grey-700 absolute top-0 bottom-1/2 left-0 right-0 z-0" />
            <div className="bg-white absolute bottom-0 top-1/2 left-0 right-0 z-0" />
          </section>
        )}
        <section className="w-full bg-white py-20">
          <div className="mx-auto prose px-6 md:px-0">{children}</div>
        </section>
      </article>
      <section className="w-full pt-52 sm:pt-96 md:pt-0 bg-white">
        <ImageDoubleCard
          imageSrc="/images/article-section-image.jpg"
          imageSrcMobile="/images/article-section-image-mobile.jpg"
          card1={
            <div className="flex flex-col py-16 md:py-20 justify-between h-full">
              <p className="text-white text-lg md:text-xl pb-8">
                {data.card1.title}
              </p>
              <Link href="/products/model-z">
                <a className="text-black text-sm md:text-base bg-pink-800 self-start rounded-full py-3 px-8 cursor-pointer">
                  Explore Grow Box
                </a>
              </Link>
            </div>
          }
          card1Style="bg-opacity-90 w-full md:w-165 px-6 md:px-28 flex-shrink-0 flex-grow-0 -mb-18 pb-18 bg-grey-700"
          card2={<NewsletterSignup />}
          card2Style="bg-taupe-500 w-full h-96 md:w-165 md:-mb-0 px-6 md:px-28 flex-shrink-0 flex-grow-0 -mb-8 pb-8"
          imageNegativeTopMargin="-mt-52 sm:-mt-96"
        />
      </section>
    </Container>
  )
}
